export class EventBus {
  static event = {
    profilePictureChanged: "profilePictureChanged",
    loadingStart: "loadingStart",
    loadingEnd: "loadingEnd",
    dataChanged: "dataChanged",
    skillMatchesComputed: "skillMatchesComputed"
  };

  on(event: any, callback: any) {
    // Store the wrapper so callers can unsubscribe (the previous impl created an anonymous
    // wrapper that could never be removed — a listener leak). Returns an unsubscribe function;
    // existing callers that ignore the return value are unaffected.
    const handler = (e: any) => callback(e.detail);
    document.addEventListener(event, handler);
    return () => document.removeEventListener(event, handler);
  }

  dispatch(event: any, data: any) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  }
}
